<!--Menu Expanded-->
<div [@sidenavTrigger] *ngIf="menuExpanded"
    class="menu-expanded border-grey__right bg-white col-2 p-3 h-100 d-flex flex-column justify-content-between shadow hidden-phone no-print"
    style="z-index: 6;">
    <div class="menu-expanded__general h-100">
        <div *ngIf="logo.url" class="menu-expanded__general__logo col-12 d-flex logo">
            <!-- <img loading="lazy" [src]="logo.url" [alt]="logo.alt"> -->
            <div style="height: 60px;"></div>
        </div>
        <!-- TITLE WITH ARROW -->
        <!-- INTESTAZIONE no link esterno e alt-view a false -->
        <a *ngIf="!levelMenu[(levelMenu.length-2)].external && !levelMenu[(levelMenu.length-2)].alt_view" class="menu-expanded__general__title d-flex align-items-center cursor-pointer" 
            [routerLink]="navigationService.splitUrlRouterLink(levelMenu[(levelMenu.length-2)].link).path" [queryParams]="navigationService.splitUrlRouterLink(levelMenu[(levelMenu.length-2)].link).queryParams"
            [ngClass]="!levelMenu[(levelMenu.length-2)].alt_view ? 'padding-local-menu' : ''">
            <div *ngIf="!levelMenu[(levelMenu.length-2)].alt_view" class="d-flex col-1">
                <img loading="lazy" src="./assets/images/arrow_left_menu-local.svg" alt="back icon">
            </div>
            <div class="col-11 px-0">
                <p class="text-uppercase ls-label-medium-semibold truncate m-0"
                    [ngClass]="!levelMenu[(levelMenu.length-2)].alt_view ? 'text-primary-g ps-1' : 'text-grey'">
                    {{levelMenu[(levelMenu.length-2)].label}}
                </p>
            </div>
        </a>
        <!-- END INTESTAZIONE no link esterno e alt-view a false -->
        <!-- INTESTAZIONE link esterno e alt-view a false -->
        <a *ngIf="levelMenu[(levelMenu.length-2)].external && !levelMenu[(levelMenu.length-2)].alt_view" class="menu-expanded__general__title d-flex align-items-center cursor-pointer" 
            [href]="(levelMenu[(levelMenu.length-2)].link)"
            [ngClass]="!levelMenu[(levelMenu.length-2)].alt_view ? 'padding-local-menu' : ''">
            <div *ngIf="!levelMenu[(levelMenu.length-2)].alt_view" class="d-flex col-1">
                <img loading="lazy" src="./assets/images/arrow_left_menu-local.svg" alt="back icon">
            </div>
            <div class="col-11 px-0">
                <p class="text-uppercase ls-label-medium-semibold truncate m-0"
                [ngClass]="!levelMenu[(levelMenu.length-2)].alt_view ? 'text-primary-g ps-1' : 'text-grey'">
                {{levelMenu[(levelMenu.length-2)].label}}
                </p>
            </div>
        </a>
        <!-- END INTESTAZIONE link esterno e alt-view a false -->
        <!-- INTESTAZIONE alt-view a true -->
        <div *ngIf="levelMenu[(levelMenu.length-2)].alt_view" class="menu-expanded__general__title d-flex align-items-center" 
            [ngClass]="!levelMenu[(levelMenu.length-2)].alt_view ? 'padding-local-menu' : ''">
            <div *ngIf="!levelMenu[(levelMenu.length-2)].alt_view" class="d-flex col-1">
                <img loading="lazy" src="./assets/images/arrow_left_menu-local.svg" alt="back icon">
            </div>
            <div class="col-11 px-0">
                <p class="text-uppercase ls-label-medium-semibold truncate m-0"
                    [ngClass]="!levelMenu[(levelMenu.length-2)].alt_view ? 'text-primary-g ps-1' : 'text-grey'">
                    {{levelMenu[(levelMenu.length-2)].label}}
                </p>
            </div>
        </div>
        <!-- END INTESTAZIONE alt-view a true -->
        <!-- END TITLE WITH ARROW -->
        <!-- BODY -->
        <div class="scroll-local-menu position-relative">
            <div *ngFor="let subtree of levelMenu[levelMenu.length-2].subtree">
                <ng-container *ngIf="subtree.enabled">
                    <div class="truncate py-2" 
                        [class.bg-gold]="subtree.link === path"
                        [class.label-hover]="subtree.link !== ''"
                    >
                        <p *ngIf="subtree.link === ''" class="text-support-40 ls-label-medium-semibold text-uppercase mt-3">
                            {{subtree.label}}
                        </p>
                        <a *ngIf="subtree.link != '' && !subtree.external" [routerLink]="navigationService.splitUrlRouterLink(subtree.link).path" [queryParams]="navigationService.splitUrlRouterLink(subtree.link).queryParams"
                            [ngClass]="subtree.link === path ? 'text-gold' : 'text-brand-10'"
                            class="no-anchor ms-3 ls-label-medium-semibold" [innerHTML]="subtree.label"></a>
                        <a *ngIf="subtree.link != '' && subtree.external" [href]="subtree.link"
                            [ngClass]="subtree.link === path ? 'text-gold' : 'text-brand-10'"
                            class="no-anchor ms-3 ls-label-medium-semibold" [innerHTML]="subtree.label"></a>
                    </div>
                    <ng-container
                        *ngIf="levelMenu[levelMenu.length-1].subtree && levelMenu[levelMenu.length-1].subtree.length > 0 && getDecodeURIComponent(subtree.link) === path">
                        <div class="" *ngFor="let subtree2 of subtree.subtree">
                            <div *ngIf="subtree2.enabled" class="py-2 truncate label-hover">
                                <a *ngIf="!subtree2.external" [routerLink]="navigationService.splitUrlRouterLink(subtree2.link).path" [queryParams]="navigationService.splitUrlRouterLink(subtree2.link).queryParams"
                                    class="text-brand-10 ls-label-medium label-menu-second" [innerHTML]="subtree2.label"></a>
                                <a *ngIf="subtree2.external" [href]="subtree2.link"
                                    class="text-brand-10 ls-label-medium label-menu-second" [innerHTML]="subtree2.label"></a>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="menu-expanded__general__container-btn-close cursor-pointer" (click)="closeMenu()">
            <img loading="lazy" src="./assets/images/side-menu-close.svg" alt="menu close">
        </div>
        <!-- END BODY -->
    </div>
</div>
<!--END Menu Expanded-->
<!--MOBILE MENU-->
<div [ngClass]="menuMobileExpanded ? 'active-nav-mobile' : 'inactive-nav-mobile'"
    class="hidden-web w-100 z-index-99 container-mobile-menu no-print">
    <div (click)="expandMobileMenu()"
        class="container-mobile-menu__general d-flex justify-content-between align-items-center text-uppercase">
        <div class="d-flex align-items-center">
            <!-- TITOLO APERTO -->
            <a *ngIf="!levelMenu[(levelMenu.length-2)].external && !levelMenu[(levelMenu.length-2)].alt_view && menuMobileExpanded" class="w-100 d-flex align-items-center"
                [ngClass]="menuMobileExpanded ? 'active-arrow text-brand-40' : 'inactive-arrow'"
                [routerLink]="navigationService.splitUrlRouterLink(levelMenu[(levelMenu.length-2)].link).path" 
                [queryParams]="navigationService.splitUrlRouterLink(levelMenu[(levelMenu.length-2)].link).queryParams">
                <i *ngIf="menuMobileExpanded" class="fa-solid fa-arrow-left pe-3" aria-hidden="true"></i>
                <p class="ls-label-medium-semibold mb-0" [ngClass]="menuMobileExpanded ? 
                    'text-brand-40' : 
                    'text-brand-10'" [innerHTML]="levelMenu[(levelMenu.length-2)].label">
                </p>
            </a>
            <a *ngIf="levelMenu[(levelMenu.length-2)].external && !levelMenu[(levelMenu.length-2)].alt_view && menuMobileExpanded" class="w-100 d-flex align-items-center"
                [ngClass]="menuMobileExpanded ? 'active-arrow text-brand-40' : 'inactive-arrow'"
                [href]="(levelMenu[(levelMenu.length-2)].link)">
                <i *ngIf="menuMobileExpanded" class="fa-solid fa-arrow-left pe-3" aria-hidden="true"></i>
                <p class="ls-label-medium-semibold mb-0" [ngClass]="menuMobileExpanded ? 
                    'text-brand-40' : 
                    'text-brand-10'" [innerHTML]="levelMenu[(levelMenu.length-2)].label">
                </p>
            </a>
            <!-- END TITOLO APERTO -->
            <!-- TITOLO CHIUSO -->
            <p *ngIf="!menuMobileExpanded" class="ls-label-medium-semibold mb-0 text-brand-10" [innerHTML]="levelMenu[(levelMenu.length-2)].label"></p>
        </div>
        <img loading="lazy" [ngClass]="{'rotate-image': menuMobileExpanded}"
            src="./assets/images/btn-local-menu-mobile.svg" alt="button menu mobile">
    </div>
    <div class="scroll-local-menu-mobile">
        <div *ngFor="let item of levelMenu[levelMenu.length-2].subtree" class="scroll-local-menu-mobile__general">
            <p *ngIf="item.link === ''"
                class="scroll-local-menu-mobile__general__title-section mb-0 truncate text-uppercase text-support-30 ls-label-small-semibold"
                [innerHTML]="item.label"></p>
            <a *ngIf="item.link != '' && item.external" [href]="item.link">
                <p [ngClass]="{'label-active-menu-mobile bg-support-99' : item.link === path}"
                    class="scroll-local-menu-mobile__general__item ls-label-large-semibold text-brand-10 mb-0 truncate" [innerHTML]="item.label"></p>
            </a>
            <a *ngIf="item.link != '' && !item.external" [routerLink]="navigationService.splitUrlRouterLink(item.link).path" [queryParams]="navigationService.splitUrlRouterLink(item.link).queryParams">
                <p [ngClass]="{'label-active-menu-mobile bg-support-99' : item.link === path}"
                    class="scroll-local-menu-mobile__general__item ls-label-large-semibold text-brand-10 mb-0 truncate" [innerHTML]="item.label">
                </p>
            </a>
            <ng-container *ngIf="item.subtree && item.subtree.length > 0 && item.link === path">
                <div *ngFor="let subitem of item.subtree" class="">
                    <div class="">
                        <a *ngIf="!subitem.external" [routerLink]="navigationService.splitUrlRouterLink(subitem.link).path" [queryParams]="navigationService.splitUrlRouterLink(subitem.link).queryParams">
                            <p class="scroll-local-menu-mobile__general__subitem ls-label-large mb-0 truncate" [innerHTML]="subitem.label">
                            </p>
                        </a>
                        <a *ngIf="subitem.external" [href]="subitem.link">
                            <p class="scroll-local-menu-mobile__general__subitem ls-label-large mb-0 truncate" [innerHTML]="subitem.label">
                            </p>
                        </a>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>